import { type AbstractControl, type ValidationErrors, type ValidatorFn } from '@angular/forms';

export function removeSpacesValidator(control: AbstractControl): ValidationErrors | null {
  if (control && control.value && !control.value.trim().length) {
    return { noSpaceAllowed: true };
  }

  return null;
}

export function duplicateValueValidator(getValues: () => string[], excludeValue?: string | null): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const controlValue = control.value?.toLowerCase();

    if (!controlValue || controlValue === excludeValue?.toLowerCase()) {
      return null;
    }

    const values = getValues();
    const isDuplicate = values.some((value) => value.toLowerCase() === controlValue);

    return isDuplicate ? { alreadyExist: true } : null;
  };
}
